import CASH from "../actions/cash/types";
import UserSocket from "../../sockets/user-socket";

const initialState = {
    roomList: [],
    waitingProcesses: [],
    filter: {
        minBet: '',
        maxBet: '',
        score: [],
        time: [],
        status: [],
        type: []
    },
};
const reducer = (state = initialState, action) => {
    const socket = UserSocket.debouncedEmit.bind(UserSocket);

        switch (action?.type) {

            case CASH.UPDATE_ROOM_LIST:
                return {
                    ...state,
                    roomList: action.payload.roomList
                }
            case CASH.ADD_WAITING_ROOM_PROCESS:
                const waitingProcesses = [...state.waitingProcesses, action.payload.process]
                return {
                    ...state,
                    waitingProcesses
                }

            case CASH.REMOVE_WAITING_PROCESS:
                const removedWaitingRoomIds = state.waitingProcesses.filter(roomId => roomId !== action.payload.data);
                return {
                    ...state,
                    waitingProcesses: removedWaitingRoomIds
                }
            case CASH.CREATE_ROOM:
                socket(CASH.EVENT, {action: action.type, payload: action.payload, ctx: 'Cash'})
                return {
                    ...state,
                    waitingProcesses: [...state.waitingProcesses, 'creating']
                }
            case CASH.JOIN_ROOM:
                socket(CASH.EVENT, {action: action.type, payload: action.payload, ctx: 'Cash'})
                return {
                    ...state,
                    waitingProcesses: [...state.waitingProcesses, action.payload]
                }

            case CASH.SET_FILTER:
                return {
                    ...state,
                    filter: {
                        ...state.filter,
                        ...action.payload
                    }
                }

            case CASH.RESET_FILTER:
                return {
                    ...state,
                    filter: initialState.filter,
                }

            default:
                return state;
        }
    }
;
export default reducer;
